import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import DeadlineCalendar from './DeadlineCalendar/DeadlineCalendar';
import './Deadline.css';

class Deadline extends Component {
  constructor(props) {
    super(props);
    this.getDayStyle = this.getDayStyle.bind(this);
    this.onChange = this.onChange.bind(this);
    this.state = { deadline: null };
  }

  getLastTooSoonDate = () => {
    const { tooSoonDays } = this.props;
    return moment()
      .startOf('day')
      .add(tooSoonDays, 'day');
  };

  getDayStyle(day) {
    const { deadline: deadlineStr } = this.props;
    const deadline = moment(deadlineStr, 'YYYY-MM-DD');
    const today = moment().startOf('day');
    const tooSoonDate = this.getLastTooSoonDate();
    const lastRushFeeDay = moment()
      .startOf('day')
      .add(7, 'day');

    if (day.isSame(deadline)) {
      return 'r-selected';
    }

    if (day.isSame(today)) {
      return 'today-date-cell';
    }

    if (day.isSameOrBefore(tooSoonDate)) {
      return 'too-soon-date-cell';
    }

    if (day.isSameOrBefore(lastRushFeeDay)) {
      return 'rush-fee-date-cell';
    }

    return 'simple-day-cell';
  }

  onChange(deadline) {
    const { handleAddDeadline } = this.props;
    this.setState(
      { deadline },
      () =>
        deadline.isAfter(this.getLastTooSoonDate())
          ? handleAddDeadline(deadline)
          : handleAddDeadline(),
    );
  }

  render() {
    const { deadline } = this.state;
    const { handleNextStep } = this.props;
    return (
      <div className="deadline-card">
        <div className="deadline-card--inner">
          <DeadlineCalendar
            onChange={this.onChange}
            getDayStyle={this.getDayStyle}
            rushFeeDays={7}
          >
            {deadline && this.renderPopupContent(deadline)}
          </DeadlineCalendar>
        </div>
        <div className="deadline-card--botton">
          <a onClick={handleNextStep} className="deadline-card--botton-skip">
            Skip, I don&apos;t have a hard deadline
          </a>
        </div>
      </div>
    );
  }

  renderPopupContent(deadline) {
    return deadline.isAfter(this.getLastTooSoonDate())
      ? this.renderRushFeeContent()
      : this.renderTooSoonContent();
  }

  renderRushFeeContent() {
    return (
      <div className="deadline-card--inner-rush-fee">
        <div className="deadline-card--inner-header">Rush Fee</div>
        <div className="deadline-card--inner-icon">
          <div className="deadline-card--inner-icon-rush-fee" />
        </div>
        <div className="deadline-card--inner-content">
          Your project will need to be handled by an account manager to meet
          this deadline.
        </div>
      </div>
    );
  }
  renderTooSoonContent() {
    return (
      <div className="deadline-card--inner-too-soon">
        <div className="deadline-card--inner-icon">
          <div className="deadline-card--inner-icon-too-soon" />
        </div>
        <div className="deadline-card--inner-header">
          Too Soon: Please pick a later date
        </div>
      </div>
    );
  }
}

Deadline.propTypes = {
  handleAddDeadline: PropTypes.func,
  handleNextStep: PropTypes.func,
  deadline: PropTypes.string,
  tooSoonDays: PropTypes.number,
};

export default Deadline;



// WEBPACK FOOTER //
// ./src/components/Deadline/Deadline.js